module.exports = __webpack_public_path__ + "img/oak-yellow-blurred.7b006a93.jpg";